import React, { useState } from 'react';
import TabBar from '../components/TabBar';
import DraftTab from '../tabs/DraftTab';
import DocumentsTab from '../tabs/DocumentsTab';
import MatterTab from '../tabs/MatterTab';
import TasksTab from '../tabs/TasksTab';

const TABS = ['Draft', 'Documents', 'Tasks', 'Matter'];

/**
 * Compose Pane — shown when composing or replying to an email.
 *
 * Tabs:
 *  Draft     — AI draft generation + matter-linked context injection
 *  Documents — Clio file browser with attachment capability
 *  Tasks     — Matter tasks (same as reading pane)
 *  Matter    — Full matter details (same as reading pane)
 *  File      — Associate a matter and queue email for Clio filing
 */
export default function ComposePane() {
    const [activeTab, setActiveTab] = useState('Draft');

    const renderTab = () => {
        switch (activeTab) {
            case 'Draft':
                return <DraftTab />;
            case 'Documents':
                return <DocumentsTab />;
            case 'Tasks':
                return <TasksTab />;
            case 'Matter':
                return <MatterTab />;
            default:
                return null;
        }
    };

    return (
        <>
            <TabBar tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} />
            {renderTab()}
        </>
    );
}
